import { PhoneBookEntry } from '@wephone-core/model/entity/phonebook';
import { IUserEntity } from '@wephone-core/model/entity/user.i';

export class ContactEntry {
  constructor(
    readonly user?: IUserEntity,
    private readonly phoneBook?: PhoneBookEntry,
  ) { }

  getFullName(): string {
    if (this.user) {
      return this.user.name;
    }
    if (this.phoneBook) {
      return (this.phoneBook.first_name || '') + ' ' + (this.phoneBook.last_name || '');
    }
  }

  public getOfficeExtension(): any {
    if (this.user && this.user.sipphone) {
      return this.user.sipphone.extension;
    }
  }

  public getOfficePhoneNumber(): any {
    if (this.user && this.user.phone) {
      return this.user.phone;
    }
  }

  public getOfficeNumber(): any {
    if (this.phoneBook) {
      return this.phoneBook.phone_office;
    }
  }

  public getMobileNumber(): any {
    if (this.phoneBook) {
      return this.phoneBook.phone_mobile;
    }
  }

  get avatarUrl(): string {
    if (!this.user) {
      return 'assets/images/avatar.png';
    }
    return this.user.avatarUrl;
  }
}
